/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fetched: NonNullable<unknown>, created: NonNullable<unknown>, updated: NonNullable<unknown> }} Messages_PulledInputs */

const cs_messages_pulled = /** @type {(inputs: Messages_PulledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Staženo ${i?.fetched}: ${i?.created} nových, ${i?.updated} aktualizovaných.`)
};

const en_messages_pulled = /** @type {(inputs: Messages_PulledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fetched ${i?.fetched}: ${i?.created} new, ${i?.updated} updated.`)
};

/**
* | output |
* | --- |
* | "Fetched {fetched}: {created} new, {updated} updated." |
*
* @param {Messages_PulledInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_pulled = /** @type {((inputs: Messages_PulledInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_PulledInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_pulled(inputs)
	return cs_messages_pulled(inputs)
});